import React from 'react';
import { Users, GraduationCap, Flame, ShieldCheck, Music, CircleDollarSign, HeartHandshake, SlidersHorizontal, Bell } from 'lucide-react';

export const FeaturesGrid = () => {
  const categories = [
    {
      icon: Users,
      badge: 'Personas',
      title: 'Conoce y organiza a tu comunidad',
      description: 'Directorio de miembros con fichas individuales, estados, segmentación por grupos de afinidad y datos de contacto.',
      tags: ['Directorio', 'Fichas', 'Estados', 'Segmentación'],
    },
    {
      icon: GraduationCap,
      badge: 'Formación',
      title: 'Acompaña cada proceso de formación',
      description: 'Niveles formativos, inscripciones, cohortes, lecciones y seguimiento del avance de cada estudiante.',
      tags: ['Niveles', 'Cohortes', 'Lecciones', 'Seguimiento'],
    },
    {
      icon: Flame,
      badge: 'Comunidad',
      title: 'Manten conectados tus grupos y células',
      description: 'Grupos comunitarios, toma de asistencia semanal, organización territorial y geolocalización en mapa.',
      tags: ['Grupos', 'Asistencia', 'Mapa', 'Territorio'],
    },
    {
      icon: ShieldCheck,
      badge: 'Liderazgo',
      title: 'Ten claridad sobre tus equipos',
      description: 'Estructura de servidores, asignación de roles, redes de supervisión y seguimiento de líderes.',
      tags: ['Servidores', 'Roles', 'Supervisión', 'Redes'],
    },
    {
      icon: Music,
      badge: 'Alabanza',
      title: 'Coordinación del ministerio musical',
      description: 'Equipos musicales, instrumentos, repertorios con letras, cronogramas de servicios y ensayos.',
      tags: ['Cronogramas', 'Repertorio', 'Equipos', 'Ensayos'],
    },
    {
      icon: CircleDollarSign,
      badge: 'Finanzas',
      title: 'Ordena la administración de tu iglesia',
      description: 'Diezmos, ofrendas, fondos especiales, verificación de ingresos e informes de auditoría en PDF.',
      tags: ['Diezmos', 'Ofrendas', 'Verificación', 'Reportes'],
    },
    {
      icon: Bell,
      badge: 'Comunicación',
      title: 'Mantén informada a tu comunidad',
      description: 'Notificaciones internas, alertas pastorales y novedades para la congregación y el equipo ministerial.',
      tags: ['Alertas', 'Notificaciones', 'Novedades'],
    },
    {
      icon: HeartHandshake,
      badge: 'Acompañamiento',
      title: 'Cuida pastoralmente a tu rebaño',
      description: 'Organización y agenda de citas de consejería pastoral con seguimiento y confidencialidad.',
      tags: ['Consejería', 'Agenda', 'Seguimiento'],
    },
    {
      icon: SlidersHorizontal,
      badge: 'Gestión',
      title: 'Administra con orden y métricas',
      description: 'Sistema de tickets, solicitudes ministeriales, indicadores de gestión y permisos por rol.',
      tags: ['Tickets', 'Indicadores', 'Permisos'],
    },
  ];

  return (
    <section id="funcionalidades" className="py-20 bg-white dark:bg-slate-900 border-t border-slate-200/60 dark:border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            Funcionalidades Reales
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            Todo lo que tu iglesia necesita, en una plataforma
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base font-medium leading-relaxed">
            Módulos reales comprobados en producción. Sin funciones de relleno, únicamente lo que tu equipo necesita.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((cat, idx) => {
            const Icon = cat.icon;
            return (
              <div
                key={idx}
                className="bg-slate-50 dark:bg-slate-950 p-8 rounded-[2.5rem] border border-slate-200/80 dark:border-slate-800/80 space-y-5 flex flex-col justify-between hover:shadow-xl hover:border-indigo-300 dark:hover:border-indigo-800 transition-all group"
              >
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="w-14 h-14 rounded-2xl bg-indigo-100 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Icon size={28} />
                    </div>
                    <span className="px-3 py-1 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-slate-700 dark:text-slate-300 rounded-full text-[10px] font-black uppercase tracking-wider">
                      {cat.badge}
                    </span>
                  </div>
                  <h3 className="text-xl font-black text-slate-900 dark:text-white tracking-tight">{cat.title}</h3>
                  <p className="text-xs font-medium text-slate-600 dark:text-slate-400 leading-relaxed">{cat.description}</p>
                </div>
                <div className="pt-4 border-t border-slate-200/60 dark:border-slate-800/60 flex flex-wrap gap-2">
                  {cat.tags.map((tag, tIdx) => (
                    <span key={tIdx} className="px-2.5 py-1 bg-indigo-50/50 dark:bg-indigo-950/30 text-indigo-700 dark:text-indigo-300 rounded-lg text-[10px] font-bold">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
